import { z } from 'zod';

import { zodLedgerAccountTypeSchema } from '../validations';

export { zodLedgerAccountSchema as zodCreateLedgerAccountResponseSchema } from '../validations';

/**
 * Create payload for a ledger account's first version. `costType` and
 * `validFrom` are the only optional fields and default server-side;
 * `validFrom` defaults to today.
 */
export const zodCreateLedgerAccountPayloadSchema = z.object({
  accountType: zodLedgerAccountTypeSchema,
  companyId: z.uuid(),
  costType: z.string().trim().max(255).optional(),
  name: z.string().trim().max(255),
  number: z.string().trim().min(1).max(64),
  validFrom: z.iso.date().optional(),
});
